module.exports = __webpack_public_path__ + "img/calendar-solid.1e3cfc0d.svg";